import React, { Component } from "react";
import { Select, alert, loading, t } from "../../components/CustomComponent.js";
import { withRouter } from "../../components/withRouter.js";

import HomeNavbar from "./components/HomeNavbar.js";
import HomeFooter from "./components/HomeFooter.js";
import HomePropertyCard from "./components/HomePropertyCard.js";

import ICON from "./icons.js";
import { DEAL_OPTIONS, PRICE_OPTIONS, BED_OPTIONS, SORT_OPTIONS, priceRange, bedFilter, openFreePost } from "./options.js";
import { loadHomeContent, loadProperties } from "./api.js";
import { favMap, favToggle, favSubscribe } from "./fav_store.js";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
import "../../assets/css/homepage.css";

/* ============================================================================
 * PropertyList — หน้ารายการทรัพย์เต็ม (/properties)
 *
 * เปิดจากหน้าแรกเป็นแท็บใหม่ได้ 3 ทาง จึงอ่านเงื่อนไขจาก query string ทั้งหมด
 * แทนที่จะรับผ่าน props — ลิงก์ที่ได้จึงคัดลอกส่งต่อและรีเฟรชได้โดยไม่เสียเงื่อนไข
 *
 *   /properties?section=featured        ทรัพย์แนะนำ (ดูทั้งหมด)
 *   /properties?section=projects        โครงการใหม่ (ประเภททรัพย์ = โครงการใหม่)
 *   /properties?q=ใกล้รถไฟฟ้า            ทางลัดไลฟ์สไตล์ / หมวดหมู่ / แนวรถไฟฟ้า
 *   /properties?zone=&type=&project=&deal=...  ปุ่มค้นหาในหน้าแรก
 *
 * ตัวกรองบนหน้านี้เป็นชุดเดียวกับกล่องค้นหาหน้าแรก แก้แล้วยิง API ใหม่ทันที
 * และเขียนกลับลง URL ให้ตรงกับสิ่งที่เห็นเสมอ
 * ========================================================================== */

/* section = ทางลัดที่มาจากหน้าแรก แปลงเป็นเงื่อนไขจริงของ API ที่นี่ที่เดียว
   หน้าแรกจึงส่งมาแค่ชื่อบล็อก ไม่ต้องรู้ว่าบล็อกนั้นกรองด้วยอะไร */
const SECTIONS = {
  featured: { title: "home_featured_title", params: { sort: "recommend" } },
  projects: { title: "home_projects_title", params: { type: "new_project", sort: "new" } },
};

const PAGE_SIZE = 12;

const EMPTY_FILTER = { q: "", zone: "", type: "", project: "", deal: "", price: "", bed: "", sort: "recommend" };

/* เงื่อนไขที่ "ติดมากับปุ่มที่กด" ไม่ใช่สิ่งที่ผู้ใช้เลือกเองบนหน้านี้
   (แท็ก / กลุ่มประเภททรัพย์ / เลี้ยงสัตว์ได้) จึงไม่มีช่องให้แก้ แต่ต้องคงไว้ใน URL
   ทุกครั้งที่ผู้ใช้ขยับตัวกรองอื่น — ไม่งั้นกรองต่อแล้วเงื่อนไขของปุ่มจะหลุดหายไป
   title = ชื่อปุ่มที่กดมา ใช้เป็นหัวข้อของหน้า แทนการโชว์ค่าดิบอย่าง "tag=promo" */
const PRESET_KEYS = ["section", "tags", "types", "pet", "title"];

class PropertyList extends Component {
  state = {
    filter: { ...EMPTY_FILTER },
    preset: {},
    items: [],
    total: 0,
    page: 1,
    zones: [],
    types: [],
    project_names: [],
    contact: null,
    ready: false,
    favorites: favMap(),
    fav_pop: "",
  };

  componentDidMount() {
    const { filter, preset } = this.fromUrl();

    document.title = `${this.heading(preset)} | SafeSpace Life Living`;
    window.scrollTo({ top: 0 });

    this.setState({ filter, preset }, this.Get);
    this.GetOptions();
    this.unsubscribeFav = favSubscribe(() => this.setState({ favorites: favMap() }));
  }

  componentWillUnmount() {
    this.unsubscribeFav();
    clearTimeout(this.fav_timer);
  }

  /* เขียนลง fav_store อย่างเดียว — state.favorites อัปเดตผ่าน favSubscribe */
  toggleFavorite = (uid) => {
    clearTimeout(this.fav_timer);
    favToggle(uid);
    this.setState({ fav_pop: uid });
    this.fav_timer = setTimeout(() => this.setState({ fav_pop: "" }), 600);
  };

  /* เงื่อนไขทั้งหมดอยู่ใน URL — อ่านกลับมาเป็นตัวกรองที่แก้ได้ + เงื่อนไขที่ติดมากับปุ่ม */
  fromUrl = () => {
    const query = new URLSearchParams(this.props.router.location.search);
    const filter = { ...EMPTY_FILTER };
    const preset = {};

    Object.keys(EMPTY_FILTER).forEach((key) => {
      const value = query.get(key);
      if (value !== null) filter[key] = value;
    });
    PRESET_KEYS.forEach((key) => {
      const value = query.get(key);
      if (value) preset[key] = value;
    });

    return { filter, preset };
  };

  /** หัวข้อของหน้า : ชื่อปุ่มที่กดมา > ชื่อบล็อกในหน้าแรก > "ค้นหาทรัพย์" */
  heading = (preset = this.state.preset) => preset.title || t(SECTIONS[preset.section]?.title || "home_nav_search");

  /* ตัวเลือกทำเล/ประเภท/โครงการมาจากทรัพย์ที่มีอยู่จริง ใช้ชุดเดียวกับกล่องค้นหาหน้าแรก
     โหลดแยกจากรายการ เพราะรายการเปลี่ยนทุกครั้งที่กรอง แต่ตัวเลือกไม่เปลี่ยน */
  GetOptions = async () => {
    const content = await loadHomeContent();
    this.setState({
      zones: content.zones || [],
      types: content.types || [],
      project_names: content.project_names || [],
      contact: content.contact,
    });
  };

  /* ปุ่มที่ยังไม่มีหน้าปลายทาง — ข้อความเดียวกับหน้าแรก */
  soon = (name) => alert("", "info", t("coming_soon_title"), `${name} — ${t("coming_soon_desc")}`, t("confirm"));

  /** เงื่อนไขที่ส่งขึ้น API = ตัวกรองบนหน้า + เงื่อนไขประจำบล็อกที่เปิดมา */
  params = (page) => {
    const { filter, preset } = this.state;
    const section = SECTIONS[preset.section]?.params || {};

    return {
      ...section,
      // เงื่อนไขที่ติดมากับปุ่ม (title เป็นแค่ข้อความบนหน้า ไม่ต้องส่งขึ้น API)
      ...(preset.tags ? { tags: preset.tags } : {}),
      ...(preset.types ? { types: preset.types } : {}),
      ...(preset.pet ? { pet: preset.pet } : {}),
      ...(filter.q ? { q: filter.q } : {}),
      ...(filter.zone ? { zone: filter.zone } : {}),
      // ประเภทที่ผู้ใช้เลือกเองชนะประเภทประจำบล็อก
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.project ? { project: filter.project } : {}),
      ...(filter.deal ? { deal: filter.deal } : {}),
      ...priceRange(filter.price),
      ...bedFilter(filter.bed),
      sort: filter.sort || section.sort || "recommend",
      page,
      limit: PAGE_SIZE,
    };
  };

  Get = async (page = 1, append = false) => {
    loading(true);
    const { items, total } = await loadProperties(this.params(page));
    loading(false);

    this.setState((state) => ({
      items: append ? [...state.items, ...items] : items,
      total,
      page,
      ready: true,
    }));
  };

  /* เปลี่ยนตัวกรอง = ยิงใหม่ตั้งแต่หน้าแรกเสมอ และเขียนเงื่อนไขกลับลง URL
     (replace ไม่ใช่ push — กดย้อนกลับจะได้ไม่ต้องไล่ผ่านทุกครั้งที่ขยับตัวกรอง) */
  setFilter = (patch) => {
    this.setState(
      (state) => ({ filter: { ...state.filter, ...patch } }),
      () => {
        const query = new URLSearchParams();
        // เงื่อนไขที่ติดมากับปุ่มต้องอยู่ใน URL ต่อไปด้วย ไม่งั้นกรองต่อแล้วหลุดหาย
        PRESET_KEYS.forEach((key) => this.state.preset[key] && query.set(key, this.state.preset[key]));
        Object.entries(this.state.filter).forEach(([key, value]) => value && query.set(key, value));
        this.props.router.navigate(`/properties?${query.toString()}`, { replace: true });
        this.Get(1);
      }
    );
  };

  // เปลี่ยนประเภทประกาศแล้วล้างช่วงราคาที่ผูกกับค่าเดิม (เช่า/ขาย คนละชุดกัน)
  setDeal = (deal) => this.setFilter({ deal, price: "" });

  openProperty = (item) => window.open(`/property/${item.id}`, "_blank", "noopener,noreferrer");

  toOptions = (options) =>
    (options || []).map((opt) => (typeof opt === "string" ? { value: opt, label: t(opt) } : { value: opt.value, label: t(opt.label) }));

  /* โครงเดียวกับ HomeHero.field — nowrap ให้รายการที่เด้งขึ้นมาโชว์ชื่อเต็มบรรทัดเดียว */
  field = (icon, value, options, onChange, placeholder) => (
    <div className="hm-field">
      <span className="hm-field__icon hm-ico">{icon}</span>
      <Select
        className="hm-field__select"
        default={false}
        nowrap
        placeholder={t(placeholder)}
        value={value}
        options={[{ value: "", label: t(placeholder) }, ...this.toOptions(options)]}
        onChange={onChange}
      />
    </div>
  );

  render() {
    const { filter, items, total, page, zones, types, project_names, contact, ready, favorites, fav_pop } = this.state;
    const priceOptions = filter.deal === "rent" ? PRICE_OPTIONS.rent : PRICE_OPTIONS.sale;
    const hasMore = items.length < total;

    return (
      <div className="mn-home">
        <HomeNavbar onPost={openFreePost} />

        <section className="hm-pl">
          <div className="hm-container">
            <div className="hm-pl__head">
              <h1 className="hm-pl__title">{this.heading()}</h1>
              {/* โชว์เฉพาะคำที่ผู้ใช้ค้นเองจริง ๆ — เงื่อนไขของปุ่มทางลัดอยู่ในหัวข้อไปแล้ว */}
              {!!filter.q && <span className="hm-pl__chip">{filter.q}</span>}
              <span className="hm-pl__count">{ready ? t("home_result_count").replace("{n}", total.toLocaleString()) : ""}</span>
            </div>

            {/* ตัวกรอง — ชุดเดียวกับกล่องค้นหาหน้าแรก บวกตัวเรียงลำดับ */}
            <div className="hm-search hm-search--flat">
              <div className="hm-search__panel">
                {this.field(ICON.marker, filter.zone, zones, (v) => this.setFilter({ zone: v }), "home_opt_zone_any")}
                {this.field(ICON.building, filter.type, types, (v) => this.setFilter({ type: v }), "home_field_type")}
                {this.field(ICON.town, filter.project, project_names, (v) => this.setFilter({ project: v }), "home_opt_project_any")}
                {this.field(ICON.tag, filter.deal, DEAL_OPTIONS, this.setDeal, "home_field_deal_any")}
                {this.field(ICON.money, filter.price, priceOptions, (v) => this.setFilter({ price: v }), "home_field_price_any")}
                {this.field(ICON.bed, filter.bed, BED_OPTIONS, (v) => this.setFilter({ bed: v }), "home_field_bed")}
                {this.field(ICON.chart_line, filter.sort, SORT_OPTIONS, (v) => this.setFilter({ sort: v || "recommend" }), "home_sort_recommend")}
              </div>
            </div>

            {items.length ? (
              <>
                <div className="hm-grid hm-grid--list">
                  {items.map((item) => (
                    <HomePropertyCard
                      key={item.id}
                      item={item}
                      favorite={favorites[item.id]}
                      pop={fav_pop === item.id}
                      onFavorite={this.toggleFavorite}
                      onOpen={this.openProperty}
                    />
                  ))}
                </div>

                {hasMore && (
                  <div className="text-center mt-4">
                    <button type="button" className="hm-btn hm-btn--ghost" onClick={() => this.Get(page + 1, true)}>
                      {t("home_load_more")}
                    </button>
                  </div>
                )}
              </>
            ) : (
              ready && <div className="text-center py-5 hm-muted">{t("home_empty")}</div>
            )}
          </div>
        </section>

        <HomeFooter
          data={contact?.footer || {}}
          socials={contact?.socials || []}
          onLink={(key) => this.soon(t(key))}
          onSubscribe={() => this.soon(t("home_footer_subscribe"))}
        />
      </div>
    );
  }
}

export default withRouter(PropertyList);
